'use strict';
import React from 'react';
import flux from 'utils/flux';
import MediaFeatured from './mediaFeatured';
import isEmpty from 'lodash/lang/isEmpty';
import MediaListingItem from './mediaListingItem';
import LoadingSpinner from 'components/spinner/spinner';
import MediaListingEmpty from './mediaListingEmpty';

var MediaListingPage = React.createClass({
    displayName: 'MediaListingPage',
    mixins: [],
    propTypes: {},
    render() {
        if (isEmpty(this.props.query)) {
            return <MediaFeatured landingPage={this.props.mediaStore.landingPage} />;
        }

        if (flux.getStore('media').isLoading()) {
            return (<LoadingSpinner/>);
        }

        if (this.props.mediaStore.media.size === 0) {
            return <MediaListingEmpty />;
        }

        return (
            <div className="media__listing">
                {this.props.mediaStore.media.map((item) => {
                    return <MediaListingItem key={'mlitem-' + item.get('id')} item={item} />;
                })}
            </div>
        );
    }
});

module.exports = MediaListingPage;



// WEBPACK FOOTER //
// ./app/pages/media/mediaListing.jsx